import { useRouter } from 'next/router'

import { Link } from '~/components'

import {
  useGetCurriculumCountryCodeFromUrlWithoutPrefix,
  useGetIsNorwegianCurriculum,
} from '~/curriculum/hooks/useGetCurriculumCountryCode'
import { useSetGradesMutation } from '~/curriculum/apis/curriculum.api'
import { useAppDispatch } from '~/redux/hooks'
import { setSelectedGradeActionCreator } from '~/redux/slices/dashboard'

import ROUTES from '~/shared/constants/routes.const'

import { curriculumSubjectContentDefault } from '../constants/curriculum.const'
import { setCurriculumSubjectContentActionCreator } from '../slice/curriculum.slice'

interface Props {
  gradeNumber: number
  text: string
  gradeOnClickUrl: string
}

export default function Grade({ gradeNumber, text, gradeOnClickUrl }: Props): React.ReactElement {
  const router = useRouter()
  const dispatch = useAppDispatch()
  const currentPath = router.asPath
  const countryCode = useGetCurriculumCountryCodeFromUrlWithoutPrefix()
  const isNorwegianCurriculum = useGetIsNorwegianCurriculum(countryCode)
  const gradeLabelFontSize = isNorwegianCurriculum ? 'text-4xl' : 'text-2xl'

  const [setGrades] = useSetGradesMutation()

  const handleOnClick = async (): Promise<void> => {
    dispatch(setSelectedGradeActionCreator(gradeNumber))
    dispatch(setCurriculumSubjectContentActionCreator(curriculumSubjectContentDefault))

    await setGrades({
      curriculumGrade: gradeNumber,
      fromOnboarding: currentPath.includes(ROUTES.ONBOARDING_SELECT_GRADE),
      replaceFullRow: true,
    })
  }

  return (
    <Link
      className="flex justify-center items-center bg-white shadow-md rounded-2.25 sm360:w-76 sm375:w-80 lg:w-72 xl:w-80 h-16"
      onClick={handleOnClick}
      to={gradeOnClickUrl}
    >
      <span
        className={`${gradeLabelFontSize} tracking-widest text-shadow-md font-bold bg-purple-portal-background text-transparent bg-clip-text`}
      >
        {text}
      </span>
    </Link>
  )
}
